import { render, staticRenderFns } from "./UserBanner.vue?vue&type=template&id=174b442b&"
import script from "./UserBanner.vue?vue&type=script&lang=js&"
export * from "./UserBanner.vue?vue&type=script&lang=js&"
import style0 from "./UserBanner.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports